const TTL = 60 * 60 * 1000; // 1 hour

const store = new Map<string, { value: unknown; expiresAt: number }>();

export async function withCache<T>(key: string, fetcher: () => Promise<T>): Promise<T> {
  const cached = store.get(key);
  if (cached && Date.now() < cached.expiresAt) return cached.value as T;
  const value = await fetcher();
  store.set(key, { value, expiresAt: Date.now() + TTL });
  return value;
}
